<div class="toggle-switch-component-wrapper w-100">
  <div class="toggle-box d-flex h-100 justify-content-between" [ngStyle]="contentStyle">
    <div
      class="row mx-0 left-icon-and-label"
      (click)="onComponentClick()"
      [ngClass]="{
        'cursor-pointer': !showToggleSwitch,
        'disable-widget': isDisabled,
        'pointer-events-none': isWorkflow
      }"
    >
      <mat-icon
        *ngIf="widgetConfigData?.icon"
        [svgIcon]="widgetConfigData.icon ?? ''"
        [ngStyle]="iconStyle"
      ></mat-icon>
      @if (widgetConfigData?.textContent) {
      <div
        [class]="widgetConfigData?.icon ? 'label-text pl-1' : 'label-text'"
        [ngStyle]="textContentStyle"
        [innerHTML]="renderedContent | safeHtml"
      ></div>
      }
    </div>
    <finx-switch
      *ngIf="showToggleSwitch"
      [isSmallSwitchButton]="true"
      [checkedValue]="widgetSettingsPropertyName ? (widgetConfigData?.[widgetSettingsPropertyName]?.isActive ?? false) : checkedValue ? checkedValue : false"
      (checkedValueChange)="onChangeValueUpdate($event)"
      [ngClass]="{ 'disable-widget': isDisabled, 'pointer-events-none': isWorkflow }"
    ></finx-switch>
  </div>
</div>
